import { render, staticRenderFns } from "./SortableHeader.vue?vue&type=template&id=c31626c2&scoped=true"
import script from "./SortableHeader.vue?vue&type=script&lang=ts"
export * from "./SortableHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31626c2",
  null
  
)

export default component.exports